import type { DocumentShareDrowdownMenuItemFragment } from "../client/generated";
import { useState } from "react";
import { Icon } from "@mdi/react";
import { DropdownMenuItem } from "@acdc2/ui/components/dropdown-menu";
import { mdiAccountPlus } from "@mdi/js";
import { useTranslation } from "react-i18next";
import { DocumentShareDialogContent } from "./DocumentShareDialogContent";
import { Dialog, DialogTrigger } from "@acdc2/ui/components/dialog";

type Props = {
  fragment: DocumentShareDrowdownMenuItemFragment;
};

export function DocumentShareDropdownMenuItem({ fragment }: Props) {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogTrigger asChild>
        <DropdownMenuItem onSelect={(e) => e.preventDefault()}>
          <Icon path={mdiAccountPlus} size="1.25rem" />
          {t("DocumentShareDropdownMenuItem.label")}
        </DropdownMenuItem>
      </DialogTrigger>
      <DocumentShareDialogContent fragment={fragment} isOpen={isOpen} />
    </Dialog>
  );
}
